// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1oZkj","content":"GlobalSearch_content__UMCn9"};